import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { auth } from '../../../firebase';
import { verifyPasswordResetCode, confirmPasswordReset } from 'firebase/auth';
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import '../login_page/login_page.css';

const ResetPasswordHandler = () => {
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [oobCode, setOobCode] = useState(null);
  const [isValid, setIsValid] = useState(false);
  const [loading, setLoading] = useState(true);

  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    // 1. Extract the oobCode from the URL (?oobCode=...)
    const queryParams = new URLSearchParams(location.search);
    const code = queryParams.get('oobCode');

    if (code) {
      setOobCode(code);
      // 2. Verify the code with Firebase
      verifyPasswordResetCode(auth, code)
        .then(() => {
          setIsValid(true);
          setLoading(false);
        })
        .catch(() => {
          alert("The reset link is invalid or has expired.");
          setLoading(false);
        });
    }
  }, [location]);

  const handleUpdatePassword = async (e) => {
    e.preventDefault();
    if (newPassword !== confirmPassword) return alert("Passwords do not match");

    try {
      await confirmPasswordReset(auth, oobCode, newPassword);
      alert("Password updated successfully! You can now login.");
      navigate('/login-parm');
    } catch (error) {
      alert("Failed to reset password: " + error.message);
    }
  };

  if (loading) return <div>Verifying request...</div>;
  if (!isValid) return <div>Invalid Link. Please request a new one.</div>;

  return (
    <div className="login-container">
      <form className="forgot-form" onSubmit={handleUpdatePassword}>
        <h2>Set New Password</h2>
        <p>Please enter new password</p>
        
        <div className="input-group-login">
          <label>New Password</label>
          <div className="password-wrapper-login">
            <input 
              type={showPassword ? "text" : "password"} 
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              required 
              style={{ width: '100%', paddingRight: '40px' }}
            />
            <button 
             className="eye-icon"
            type="button" 
            onClick={() => setShowPassword(!showPassword)}
            style={{
                    position: 'absolute',
                    right: '10px',
                    top: '50%',
                    transform: 'translateY(-50%)',
                    background: 'none',
                    border: 'none',
                    cursor: 'pointer'
                  }}
            >
              {showPassword ? <FaEyeSlash /> : <FaEye />}
            </button>
          </div>
        </div>

        <div className="input-group-login">
          <label>Confirm New Password</label>
          <input 
            type={showPassword ? "text" : "password"} 
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            required 
          />
        </div>

        <button type="submit" className="login-btn">Update Password</button>
      </form>
    </div>
  );
};

export default ResetPasswordHandler;